import React from 'react';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ShieldIcon from '@mui/icons-material/Shield';
import LockIcon from '@mui/icons-material/Lock';
import CreditCardIcon from '@mui/icons-material/CreditCard';
export function Hero() {
  const features = ['100% Digital', 'Acceso en 5 min', 'Para toda Argentina', 'Técnica Gourmet + Negocio', 'Ganás desde el primer pedido'];
  return <section className="pt-6 pb-8 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-186">
      <div className="flex flex-col lg:flex-row items-center gap-6" data-id="element-187">
        <motion.div className="flex-1 text-center lg:text-left" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-188">
          <div className="inline-block bg-brand-gold text-white font-bold px-3 py-0.5 rounded-full text-xs mb-2 tracking-wider" data-id="element-189">
            🥖 MIGA MASTER PRO™
          </div>

          <h1 className="text-xl md:text-2xl lg:text-3xl font-serif font-bold text-brand-dark mb-1 leading-tight" data-id="element-190">
            Todo lo que necesitás para emprender con sándwiches de miga.
          </h1>

          <h2 className="text-lg md:text-xl font-serif text-brand-gold font-semibold mb-2" data-id="element-191">
            Gana tus Primeros $800.000 a 1Millon tu Primer Mes.
          </h2>

          <div className="relative mb-3 max-w-[300px] mx-auto lg:mx-0" data-id="element-192">
            <div className="absolute inset-0 bg-brand-gold opacity-10 rounded-xl transform rotate-2 scale-105" data-id="element-193"></div>
            <img src="https://cdn.magicpatterns.com/uploads/wRayG57HhtqUQb4ekiFVoA/en_la_tablet_202604271505.jpg" alt="Miga Master Pro - Libros y Tablet" className="relative z-10 w-full h-auto rounded-lg shadow-lg object-cover" data-id="element-194" />
          </div>

          <p className="md:text-lg text-brand-gray mb-3 max-w-2xl mx-auto lg:mx-0 text-[13px]" data-id="element-195">
            El sistema N°1 para emprender con sándwiches de miga desde casa en
            Argentina. Recetas + Técnicas + Calculadora + Guiones de Venta
            listos para usar.
            <br data-id="element-196" />
            <span className="font-semibold text-brand-dark" data-id="element-197">
              Sin adivinar. Sin perder tiempo. Sin trabajar gratis.
            </span>
          </p>

          <div className="flex flex-row flex-wrap gap-1 mb-3 justify-center lg:justify-start" data-id="element-198">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-1 bg-white px-2 py-0.5 rounded-md shadow-sm border border-brand-lightGray" data-id="element-199">
                <CheckCircleIcon className="text-brand-gold" style={{
              fontSize: 13
            }} data-id="element-200" />
                <span className="text-[10px] font-medium text-brand-dark whitespace-nowrap" data-id="element-201">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="flex flex-col items-center lg:items-start gap-2" data-id="element-202">
            <a href="#pricing" onClick={e => {
            e.preventDefault();
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="w-full sm:w-auto bg-brand-gold hover:bg-brand-goldHover text-white font-bold text-base py-3 px-6 rounded-xl shadow-lg transition-all transform hover:-translate-y-1 text-center" data-id="element-203">
              🛒 → QUIERO MI MIGA MASTER PRO AHORA
            </a>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-brand-gray mt-0.5" data-id="element-204">
              <div className="flex items-center gap-1" data-id="element-205">
                <ShieldIcon style={{
                fontSize: 14
              }} className="text-brand-gold" data-id="element-206" />
                <span data-id="element-207">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-208">
                <LockIcon style={{
                fontSize: 14
              }} className="text-brand-gold" data-id="element-209" />
                <span data-id="element-210">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-211">
                <CreditCardIcon style={{
                fontSize: 14
              }} className="text-brand-gold" data-id="element-212" />
                <span data-id="element-213">Mercado Pago | Tarjeta | Transferencia</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div className="flex-1 w-full max-w-sm lg:max-w-md" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-214">
          <div className="relative" data-id="element-215">
            <div className="absolute inset-0 bg-brand-gold opacity-10 rounded-2xl transform rotate-3 scale-105" data-id="element-216"></div>
            <img src="https://cdn.magicpatterns.com/uploads/wRayG57HhtqUQb4ekiFVoA/en_la_tablet_202604271505.jpg" alt="Miga Master Pro - Libros y Tablet" className="relative z-10 w-full h-auto rounded-xl shadow-2xl object-cover" data-id="element-217" />
          </div>
        </motion.div>
      </div>
    </section>;
}